var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded p-3 d-flex flex-column justify-content-between balance_card"},[_c('h6',{staticClass:"mb-1 fw-normal d-block"},[_vm._v("Доступный баланс")]),_c('b',{staticClass:"fs-5"},[_vm._v(_vm._s(_vm.balance)+" "+_vm._s(_vm.crypto.currency?.code))])])
}
var staticRenderFns = []

export { render, staticRenderFns }